import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api/index";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { InformationListViewModel } from "./Models/InformationListViewModel";
import MypageBadge from "~/components/MypageBadge.vue";
import { CookieHelper } from "~/extensions/utils/CookieHelper";
import { HanyoKb, InformationDetailBeforeRouteKbn, isAnswered, PageID, ReadId, Weightid } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("Information");
export default defineComponent({
    name: "InformationList",
    components: {
        MypageBadge,
        BreadcrumbList
    },
    async setup() {
        const router = useRouter();
        const result = ref(new InformationListViewModel());
        const message = commonStore.messages.PI0012;
        const weightKbn = HanyoKb.InformationWeight;
        const responsesKbn = HanyoKb.ResponsesKbn;
        const weightid = Weightid.weight;
        const notAnswered = isAnswered.notAnswered;
        const answered = isAnswered.answered;
        const readKbn = HanyoKb.InformationRead;
        const readId = ReadId.notRead;
        const pageName = commonStore.pageName(PageID.informationList);
        // テーブルカラム
        const columns = [
            { name: "weight", label: "重要", align: "center", field: "weight", sortable: true },
            { name: "isResponseRequired", label: "要回答", align: "center", field: "isResponseRequired", sortable: true },
            { name: "startAt", label: "掲載日", align: "center", field: "startAt", sortable: true },
            { name: "responseDeadline", label: "回答期限", align: "center", field: "responseDeadline", sortable: true },
            { name: "subject", label: "タイトル", align: "left", field: "subject", sortable: true },
            { name: "new", label: "", align: "right", field: "new", sortable: false }
        ];
        //行押下時の処理
        const onClick = (informationNo) => {
            CookieHelper.set("informationDetailBeforeRoute", InformationDetailBeforeRouteKbn.InformationList.toString());
            router.push({ name: "information-detail", query: { informationNo: informationNo } });
        };
        // 初期表示処理
        try {
            let infoDate = await api.information.find();
            result.value = new InformationListViewModel(infoDate);
        }
        catch (ex) {
            await MsgBox.error(ex.data.errorMessage);
            log.error("find", ex);
        }
        return {
            PageID,
            pageName,
            message,
            result,
            columns,
            weightKbn,
            weightid,
            responsesKbn,
            notAnswered,
            answered,
            readKbn,
            readId,
            onClick
        };
    }
});
